import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';

export class PreviewComponent extends Component {
  render() {
    const { selectedComponent, config, intl } = this.props;
    let otherProps = { intl };
    if (config) {
      otherProps = {
        ...(config.helper || null),
        ...config.general,
      };
    }

    return (
      <Field
        name="name"
        component={selectedComponent}
        {...otherProps}
        intl={intl}
        limit={{
          min: 6,
          max: 18,
        }}
      />
    );
  }
}

PreviewComponent.propTypes = {
  config: PropTypes.object,
  selectedComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  intl: PropTypes.object,
};

export default reduxForm({ form: 'preview' })(PreviewComponent);
